// Named this way because the API specifically revolves around
// Adding/Removing a single item from multiple playlists

import { useMutation, useQueryClient } from "react-query";
import { AxiosError } from "axios";
import {
  PlaylistResponse,
  putItemInPlaylists,
  UpdatePlaylistItem,
} from "@/api";
import { useUser } from "@/providers/context";

export const usePutItemInPlaylists = () => {
  const queryClient = useQueryClient();
  const { uid } = useUser();

  return useMutation<
    PlaylistResponse | undefined,
    AxiosError<{ error: string }>,
    UpdatePlaylistItem
  >(
    async (payload) => {
      if (uid) {
        return putItemInPlaylists({ user_id: uid, ...payload });
      }
    },
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.setQueryData(["playlists", uid], data);
        }
      },
    },
  );
};
